
<template>
  <div class="headPortrait">

    <!-- 下拉 -->
    <el-dropdown>
      <span class="el-dropdown-link">
        <img src="../../assets/images/public/headPortrait.png" class="el-icon--right"><span>{{ userInfo.username }}</span>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="drawer = true">{{ $t('navigationBar.personalInfo') }}</el-dropdown-item>
          <el-dropdown-item @click="dialogVisible = true">{{ $t('navigationBar.changePassword') }}</el-dropdown-item>
          <el-dropdown-item @click="outLogin">{{ $t('navbar.logOut') }}</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <!-- 右侧栏 -->
    <el-drawer v-model="drawer" :title="$t('navigationBar.personalInfo')">
      <p class="field">{{ $t('login.company_id') }}<span class="field-text">{{ userInfo.company_id }}</span></p>
      <p class="field">{{ $t('account.user') }}<span class="field-text">{{ userInfo.username }}</span></p>
      <p class="field">{{ $t('account.roles') }}<span class="field-text">{{ userInfo.username == 'admin' ?
        $t('navigationBar.administrator') : $t('navigationBar.domesticConsumer') }}</span></p>
      <p class="field">{{ $t('account.LastonlineTime') }}<span class="field-text">{{  moment(userInfo.login_time*1000).format(momentStamp('dateTime')) }}</span></p>
    </el-drawer>


    <!-- 修改密码弹窗 -->
    <el-dialog v-model="dialogVisible" :close-on-click-modal="false" close-on-press-escape="false" destroy-on-close
      :title="$t('navigationBar.changePassword')" width="45%" @close="dialogClose">
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
        <el-form-item :class="{label_width:true}" :label="$t('navigationBar.originalPsd')" prop="oldPassWord">
          <el-input v-model="ruleForm.oldPassWord" :placeholder="$t('navigationBar.EnterOriginalPsd')" maxlength="20"
            :type="oldEyeFlag ? 'password' : 'text'" />
          <img @click="eyeChange(1)" class="eye" :src="oldEyeFlag ? eyeSrcHide : eyeSrcShow">
        </el-form-item>
        <el-form-item :class="{label_width:true}" :label="$t('navigationBar.newPassword')" prop="newPassword">
          <el-input v-model="ruleForm.newPassword" :placeholder="$t('account.pleaseuserpasnumb')" minlength="6"
            maxlength="20" :type="newEyeFlag ? 'password' : 'text'" />
          <img @click="eyeChange(2)" class="eye" :src="newEyeFlag ? eyeSrcHide : eyeSrcShow">
        </el-form-item>
        <el-form-item :class="{label_width:true}" :label="$t('navigationBar.confirmPassword')" prop="confirmNewPassword">
          <el-input v-model="ruleForm.confirmNewPassword" :placeholder="$t('navigationBar.EntertheNewPsdAga')"
            minlength="6" maxlength="20" :type="confirmNewEyeFlag ? 'password' : 'text'" />
          <img @click="eyeChange(3)" class="eye" :src="confirmNewEyeFlag ? eyeSrcHide : eyeSrcShow">
        </el-form-item>
      </el-form>
      <div class="border-bt"></div>
      <div class="dialog-footer">
        <el-button @click="resetForm(ruleFormRef)">{{ $t('universality.cancel') }}</el-button>
        <el-button v-if="btnSubmit" type="primary" @click="submitForm(ruleFormRef)">{{ $t('universality.confirm')
        }}</el-button>
        <el-button v-else type="primary" disabled>{{ $t('universality.confirm') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script lang="ts">
import { updatePasssword } from "@/apis/user";
import { ElMessage } from "element-plus";
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { chineseVerification } from '@/utils/validate'
import { momentStamp } from '@/utils/robot'
import i18n from "@/locales";
const _t = i18n.global.t;
import { getLanguage } from "@/utils/cookies";

import { useI18n } from 'vue-i18n'
import moment from "moment";

const store = useStore()
const router = useRouter()

export default defineComponent({
  name: 'headPortrait',
  components: {
  },
  emits: ['change', 'signOutLogin'],
  props: {

  },
  setup(props: any, { emit }: any) {
    const { t } = useI18n()
    const state = reactive({
      oldEyeFlag: true,
      newEyeFlag: true,
      enStyle: false,
      confirmNewEyeFlag: true,
      eyeSrcHide: require('../../assets/images/public/passWord-hide.png'),
      eyeSrcShow: require('../../assets/images/public/passWord-show.png'),
      btnSubmit: false,
      ruleForm: {
        oldPassWord: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      rules: {
        oldPassWord: [{ required: true, message: t('navigationBar.pleaseEnterOriginalPsd'), trigger: 'blur' }, { min: 6, max: 20, message: _t('account.pleaseuserpasnumb'), trigger: "blur" }],
        newPassword: [{ required: true, message: t('navigationBar.pleaseNewpassword'), trigger: 'blur' }, { min: 6, max: 20, message: _t('account.pleaseuserpasnumb'), trigger: "blur" }],
        confirmNewPassword: [{ required: true, message: t('navigationBar.PleEntertheNewPsdAga'), trigger: 'blur' }, { min: 6, max: 20, message: _t('account.pleaseuserpasnumb'), trigger: "blur" },],
      },
      drawer: false,
      userInfo: '' as any,
      dialogVisible: false
    })

    const methods = reactive({
      eyeChange(num: number) {

        if (num == 1) {
          state.oldEyeFlag = !state.oldEyeFlag
        } else if (num == 2) {
          state.newEyeFlag = !state.newEyeFlag
        } else if (num == 3) {
          state.confirmNewEyeFlag = !state.confirmNewEyeFlag
        }

      },

      dialogClose() {
        state.btnSubmit = false
        state.ruleForm.oldPassWord = ''
        state.ruleForm.newPassword = ''
        state.ruleForm.confirmNewPassword = ''
        state.oldEyeFlag = true
        state.newEyeFlag = true
        state.confirmNewEyeFlag = true
      },
      submitForm(formEl: any) {

        if (state.ruleForm.newPassword == state.ruleForm.oldPassWord) {
          ElMessage.error(t('navigationBar.TheNewPasastheoldone'))
          return
        }
        else if (state.ruleForm.newPassword != state.ruleForm.confirmNewPassword) {
          ElMessage.error(t('navigationBar.Psdisinconsistentwith'))
          return
        }

        let params = {
          new_password: state.ruleForm.newPassword,
          old_password: state.ruleForm.oldPassWord
        }
        updatePasssword(params).then((res: any) => {
          if (res.code == '200') {
            ElMessage({
              message: t('navigationBar.modifySuccessfully'),
              type: 'success',
            })
            state.dialogVisible = false
            emit('signOutLogin', true)
          } else {
            if (res.code == '40004') {
              ElMessage.error(_t('login.confirmAndNewParrword'))
            } else if (res.code == '40006') {
              ElMessage.error(_t('login.oldPasswordError'))
            } else {
              ElMessage.error(`${res.msg}`)
            }
          }

        })
      },
      resetForm(formEl: any) {
        state.dialogVisible = false
        if (!formEl) return
        formEl.resetFields()
      },
      outLogin() {
        emit('signOutLogin')
        // state.dialogFlag = true
      }
    })

    onMounted(() => {
      // state.userInfo = localStorage.getItem('userInfo')
      // state.userInfo = JSON.parse(state.userInfo)
      state.userInfo = store.state.user.getacct
      let language = getLanguage()
      if(language == 'en'){
        state.enStyle = true
      }else {
        state.enStyle = false
      }
    })

    watch(() => ({ ...state.ruleForm }), (newValue, oldValue) => {
      if (newValue.oldPassWord) {
        state.ruleForm.oldPassWord = chineseVerification(newValue.oldPassWord)
      }
      if (newValue.newPassword) {
        state.ruleForm.newPassword = chineseVerification(newValue.newPassword)
      }
      if (newValue.confirmNewPassword) {
        state.ruleForm.confirmNewPassword = chineseVerification(newValue.confirmNewPassword)
      }
      if (newValue.oldPassWord.length >= 6 && newValue.newPassword.length >= 6 && newValue.confirmNewPassword.length >= 6) {
        state.btnSubmit = true
      } else {
        state.btnSubmit = false
      }
    })

    return {
      ...toRefs(state),
      ...toRefs(methods),
      moment,
      momentStamp
    }
  }
})

</script>

<style lang="scss">
.headPortrait {

  .el-dialog__header {
    position: relative;
    display: block;
  }

  .el-form-item {
    margin-left: 12%;
  }

  .el-form-item__label{
    min-width: 120px !important;
  }
  // 英文样式
  .label_width{
    .el-form-item__label{
      min-width: 210px !important;
    }
  }

  .el-form-item__content {
    width: 60%;
  }

  .el-dialog__header:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 1px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    transform-origin: 0 0;
  }

  .el-dialog__header:before {
    content: " ";
    position: absolute;
    left: 0;
    bottom: -272%;
    width: 100%;
    height: 1px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    transform-origin: 0 0;
  }


  .el-dialog__body {
    padding: 30px 20px 6px 20px;
  }


  .dialog-footer {
    margin-top: 40px;
    text-align: right;
  }


  .dialog-footer button:first-child {
    margin-right: 10px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
  }

  .el-icon--right {
    margin-right: 6px;
  }

  .field {
    margin-left: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
  }

  .field-text {
    margin-left: 10px;
    height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
  }

  .demo-ruleForm {
    margin-right: 17%;
  }

  .el-form-item__content {
    position: relative;
  }

  .eye {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 18px;
    height: 18px;
  }
}
</style>
